import React from 'react';
import { OBJECT_TYPE_PAGES } from '../../Constants';
import { PeopleIcon } from '../../Icons';
import { Nullable, SearchItemViewModel, SearchMeta } from '../types';
import { MenuItem } from '../../useSearchableMenuItems';

function renderItem(menuItem: MenuItem): Nullable<SearchItemViewModel> {
  return {
    title: `${menuItem.parentLabel ? `${menuItem.parentLabel} -> ` : ''}${
      menuItem.label
    }`,
    descriptionFields: [],
    href: menuItem.url,
  };
}

export const Navigation: SearchMeta = {
  objectType: OBJECT_TYPE_PAGES,
  objectLabelI18n: 'Navigation',
  needsPermission: false,
  tabIcon: <PeopleIcon />,
  hasAdvancedSearch: false,
  renderItem,
};
